import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { translate } from 'react-polyglot'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Tippy from '@tippy.js/react'
import EditList from '@productboard/slate-edit-list'
// import EditList from '../../Plugins/front-slate-edit-list'

import { Tooltip, ButtonGroup, Button, Icon, Shortcut } from 'components'
import Toolbar from 'components/Editor/Components/Toolbars/Toolbar'
import EditBlockquote from '@guestbell/slate-edit-blockquote' // https://github.com/guestbell/slate-plugins
import CodeBlock from '../../../Plugins/SlateCodeBlock'

const DEFAULT_NODE = 'paragraph'

const codeBlockPlugin = CodeBlock({
	containerType: 'code_block',
	lineType: 'code_line',
})

const editListPlugin = EditList({
	types: ['numbered-list', 'bulleted-list'],
	typeItem: 'list-item',
	typeDefault: 'paragraph',
})

const editBlockquotePlugin = EditBlockquote({
	type: 'block-quote',
	typeDefault: 'paragraph',
})

const editHintPlugin = EditBlockquote({
	type: 'hint',
	typeDefault: 'paragraph',
})

class InlineToolbarComponent extends Component {
	state = {
		linkInputVisible: false,
		inlineToolbarVisible: false,
		linkUrl: '',
	}

	constructor(props) {
		super(props)

		this.linkHrefInput = React.createRef()
	}

	componentDidUpdate(prevProps) {
		const { value, entryRef } = this.props

		const link = value.inlines.filter(node => node.type === 'link').first()

		if (value.fragment.text !== prevProps.value.fragment.text) {
			this.updatePosition()
			this.setState({ linkUrl: '' })
		}

		if (value.fragment.text !== prevProps.value.fragment.text && link) {
			this.setState({ linkUrl: link.data.get('href') })
		}

		if (value.fragment.text === '') {
			this.hide()
		}

		document.addEventListener('mousedown', this.handleClickOutside)
		window.addEventListener('resize', this.updatePosition)
		entryRef.current.parentNode.parentNode.addEventListener(
			'scroll',
			this.updatePosition
		)
	}

	componentWillUnmount() {
		// const {
		// 	entryRef,
		// } = this.props

		document.removeEventListener('mousedown', this.handleClickOutside)
		window.removeEventListener('resize', this.updatePosition)

		// entryRef.current.parentNode.parentNode.removeEventListener('scroll', this.updatePosition)
	}

	handleClickOutside = event => {
		const { forwardedRef } = this.props

		const container = forwardedRef.current

		if (container && !container.contains(event.target)) {
			this.hide()
		}
	}

	updatePosition = () => {
		const { forwardedRef, value } = this.props

		const inlineToolbar = forwardedRef.current

		if (!inlineToolbar) {
			return
		}

		const { fragment, selection } = value

		// console.log(value)
		// console.log(selection.isBlurred)
		// console.log(selection.isCollapsed)
		// console.log(fragment.text === '')

		// if (value.focusBlock) {
		// 	console.log(value.focusBlock.type === 'code_line')
		// }

		// console.log(value.focusBlock)

		if (
			// selection.isBlurred
			// ||
			selection.isCollapsed ||
			fragment.text === '' ||
			(value.focusBlock && value.focusBlock.type === 'code_line')
		) {
			return
		}

		this.show()

		const native = window.getSelection()
		const range = native.getRangeAt(0)
		const rect = range.getBoundingClientRect()

		inlineToolbar.style.top = `${parseInt(rect.top, 10) -
			inlineToolbar.offsetHeight}px`
		inlineToolbar.style.left = `${rect.left -
			inlineToolbar.offsetWidth / 2 +
			rect.width / 2}px`
	}

	show = () => {
		const { inlineToolbarVisible } = this.state

		if (!inlineToolbarVisible) {
			this.setState({ inlineToolbarVisible: true })
		}
	}

	hide = () => {
		const { inlineToolbarVisible, linkInputVisible } = this.state

		if (inlineToolbarVisible) {
			this.setState({ inlineToolbarVisible: false })
		}

		if (linkInputVisible) {
			this.setState({ linkInputVisible: false })
		}
	}

	onCreate = tippy => {
		this.tippy = tippy
	}

	closeTippy = () => {
		this.tippy.hide()
	}

	onClickMark = (event, type) => {
		event.preventDefault()

		const { editor } = this.props

		editor.toggleMark(type)
	}

	onClickBlock = (event, type) => {
		event.preventDefault()

		const { editor } = this.props
		const {
			value,
			value: { document },
		} = editor
		const {
			wrapInList,
			unwrapList,
			// increaseItemDepth,
			// decreaseItemDepth,
		} = editListPlugin.changes

		const isHeadline =
			this.hasBlock('heading-two') || this.hasBlock('heading-three')
		const isCodeBlock = codeBlockPlugin.utils.isInCodeBlock(value)
		const isList = editListPlugin.utils.isSelectionInList(value)
		const isBlockquote = editBlockquotePlugin.utils.isSelectionInBlockquote(
			value
		)
		const isHint = editHintPlugin.utils.isSelectionInBlockquote(value)

		// If type is changing and old type is special, unwrap first
		// Codeblock
		if (type !== 'code-block' && isCodeBlock) {
			codeBlockPlugin.changes.unwrapCodeBlock(editor)
		}

		// Blockquote
		if (type !== 'block-quote' && isBlockquote) {
			editBlockquotePlugin.changes.unwrapBlockquote(editor)
		}

		// Hint
		if (type !== 'hint' && isHint) {
			editHintPlugin.changes.unwrapBlockquote(editor)
		}

		// Hint
		if (type !== 'bulleted-list' && type !== 'numbered-list' && isList) {
			editor.command(unwrapList)
		}

		if (
			!(
				isHeadline &&
				(type === 'heading-two' || type === 'heading-three')
			)
		) {
			editor.unwrapBlock('heading-two')
			editor.unwrapBlock('heading-three')
			editor.setBlocks('paragraph')
		}

		// Wrap special
		if (type === 'code-block') {
			codeBlockPlugin.changes.wrapCodeBlock(editor)

			// if (isCodeBlock) {
			// 	codeBlockPlugin.changes.unwrapCodeBlock(editor)
			// } else {
			// 	codeBlockPlugin.changes.wrapCodeBlock(editor)
			// }

			return
		}

		if (type === 'block-quote') {
			if (isBlockquote) {
				editBlockquotePlugin.changes.unwrapBlockquote(editor)
			} else {
				editBlockquotePlugin.changes.wrapInBlockquote(editor)
			}

			return
		}

		if (type === 'hint') {
			if (isHint) {
				editHintPlugin.changes.unwrapBlockquote(editor)
			} else {
				editHintPlugin.changes.wrapInBlockquote(editor)
			}

			return
		}

		// Handle everything but lists
		if (type !== 'bulleted-list' && type !== 'numbered-list') {
			const isActive = this.hasBlock(type)

			if (isList) {
				editor.command(unwrapList).setBlocks(type)
			} else {
				editor.setBlocks(isActive ? DEFAULT_NODE : type)
			}
		} else {
			let isType = false

			if (isList) {
				const parent = document.getParent(value.blocks.first().key)
				const grandparent = document.getParent(parent.key)

				isType = grandparent && grandparent.type === type
			}

			if (isList && isType) {
				editor.command(unwrapList)
			} else if (isList) {
				editor.command(unwrapList)
				editor.command(wrapInList, type).setBlocks(DEFAULT_NODE)
			} else {
				editor.command(wrapInList, type).setBlocks(DEFAULT_NODE)
			}
		}
	}

	onClickLink = event => {
		event.preventDefault()

		this.setState({ linkInputVisible: true })
	}

	handleKeyUp = event => {
		const { linkUrl } = this.state
		const { editor } = this.props

		if (event.keyCode === 13) {
			editor.command(this.wrapLink, linkUrl)
			this.hide()
		}

		if (event.keyCode === 27) {
			this.hide()
		}
	}

	handleChange = e => {
		const cursor = e.target.selectionStart
		this.setState({ linkUrl: e.target.value }, () => {
			if (this.linkHrefInput.current != null)
				this.linkHrefInput.current.selectionEnd = cursor
		})
	}

	wrapLink = (editor, href) => {
		this.unwrapLink(editor)

		editor.wrapInline({
			type: 'link',
			data: { href },
		})

		editor.moveToEnd()
	}

	unwrapLink = editor => {
		editor.unwrapInline('link')
	}

	hasLinks = () => {
		const {
			editor: { value },
		} = this.props

		return value.inlines.some(inline => inline.type === 'link')
	}

	hasBlock = type => {
		const {
			editor: { value },
		} = this.props

		return value.blocks.some(node => node.type === type)
	}

	renderButtonGroupItems = () => [
		this.renderMarkButton('bold', 'rte_strong', 'setBold'),
		this.renderMarkButton('italic', 'rte_italic', 'setItalic'),
		this.renderMarkButton(
			'strikethrough',
			'rte_strikethrough',
			'setStrikedThrough'
		),
		this.renderMarkButton('important', 'rte_markered', 'setHighlight'),
		this.renderMarkButton('code', 'rte_code', 'setCode'),
		this.renderLinkButton('setLink', 'rte_link', 'setLink'),
		this.renderDivider(),
		this.renderBlockButton('heading-two', 'rte_h1', 'setH2'),
		this.renderBlockButton('heading-three', 'rte_h2', 'setH3'),
		this.renderBlockButton(
			'bulleted-list',
			'rte_unordered-list',
			'setUnorderedList'
		),
		this.renderBlockButton(
			'numbered-list',
			'rte_ordered-list',
			'setOrderedList'
		),
	]

	renderFurtherButtonGroupItems = () => [
		this.renderBlockButton(
			'code-block',
			'rte_codeblock',
			'setCodeBlock',
			true
		),
		this.renderBlockButton('hint', 'info', 'setHint', true),
		this.renderBlockButton(
			'block-quote',
			'rte_quote',
			'setBlockquote',
			true
		),
	]

	renderDivider = () => (
		<hr className="o-button-group__divider" key={Math.random()} />
	)

	renderMarkButton = (type, icon, hotkey, showLabel = false) => {
		const {
			editor: { value },
			t,
		} = this.props
		const isActive = value.activeMarks.some(mark => mark.type === type)
		const onMouseDown = event => this.onClickMark(event, type)

		return showLabel ? (
			<Button
				icon={<Icon name={icon} />}
				onMouseDown={event => {
					onMouseDown(event)
					this.closeTippy()
				}}
				className={isActive ? 'is-active' : ''}
				highContrast
				text={t(`commands.${hotkey}`)}
				layout="tertiary"
				fullWidth
				key={type}
				size="small"
				metaContent={<Shortcut commandKey={hotkey} />}
			/>
		) : (
			<Tooltip
				key={type}
				title={t(`commands.${hotkey}`)}
				description={<Shortcut commandKey={hotkey} />}
			>
				<Button
					icon={<Icon name={icon} />}
					onMouseDown={onMouseDown}
					className={isActive ? 'is-active' : ''}
					highContrast
				/>
			</Tooltip>
		)
	}

	renderTooltip = (hotkey, type, children) => {
		const { t } = this.props

		return hotkey ? (
			<Tooltip
				key={type}
				title={t(`commands.${hotkey}`)}
				description={<Shortcut commandKey={hotkey} />}
			>
				{children}
			</Tooltip>
		) : (
			children
		)
	}

	renderBlockButton = (type, icon, hotkey, showLabel = false) => {
		const {
			editor: {
				value,
				value: { document },
			},
			t,
		} = this.props

		let isActive = this.hasBlock(type)

		if (type === 'block-quote') {
			const isBlockquote = editBlockquotePlugin.utils.isSelectionInBlockquote(
				value
			)

			if (isBlockquote) {
				isActive = true
			}
		} else if (type === 'hint') {
			const isHint = editHintPlugin.utils.isSelectionInBlockquote(value)

			if (isHint) {
				isActive = true
			}
		} else if (['numbered-list', 'bulleted-list'].includes(type)) {
			const isList = editListPlugin.utils.isSelectionInList(value)

			if (isList) {
				const parent = document.getParent(value.blocks.first().key)
				const grandparent = document.getParent(parent.key)

				isActive = isList && grandparent && grandparent.type === type
			}
		}

		const button = (
			<Button
				key={type}
				icon={<Icon name={icon} />}
				onMouseDown={event => {
					this.onClickBlock(event, type)
					this.closeTippy()
				}}
				className={isActive ? 'is-active' : ''}
				highContrast
				text={showLabel ? t(`commands.${hotkey}`) : null}
				layout={showLabel ? 'tertiary' : null}
				fullWidth={showLabel}
				size={showLabel ? 'small' : null}
				metaContent={
					showLabel ? <Shortcut commandKey={hotkey} /> : null
				}
			/>
		)

		return showLabel ? button : this.renderTooltip(hotkey, type, button)
	}

	renderLinkButton = (type, icon, hotkey) => {
		const hasLinks = this.hasLinks()

		const button = (
			<Button
				key={type}
				icon={<Icon name={icon} />}
				onMouseDown={event => this.onClickLink(event)}
				className={hasLinks ? 'is-active' : ''}
				highContrast
			/>
		)

		return this.renderTooltip(hotkey, type, button)
	}

	renderLinkInput = () => {
		const { linkInputVisible, linkUrl } = this.state

		const { editor, t } = this.props
		const hasLinks = this.hasLinks()

		return (
			<div
				className={classNames(
					'o-toolbar__overlay',
					linkInputVisible && 'is-visible'
				)}
				key={Math.random()}
			>
				<Icon name="rte_link" />
				<input
					className="o-toolbar__overlay-input"
					type="text"
					placeholder={t('editor.enter_link_url')}
					ref={this.linkHrefInput}
					value={linkUrl}
					autoFocus
					onChange={this.handleChange}
					onKeyUp={this.handleKeyUp}
					// onFocus={event => event.target.select()}
				/>
				<Button
					layout="ghosted"
					size="small"
					text={t('editor.link')}
					onMouseDown={() => editor.command(this.wrapLink, linkUrl)}
				/>
				{hasLinks && (
					<Button
						layout="ghosted"
						size="small"
						icon={<Icon name="delete" />}
						onMouseDown={() => editor.command(this.unwrapLink)}
					/>
				)}
			</div>
		)
	}

	render() {
		const { editor, forwardedRef } = this.props

		const { inlineToolbarVisible } = this.state

		if (!editor) {
			return null
		}

		return ReactDOM.createPortal(
			<Toolbar
				toolbarRef={forwardedRef}
				className={classNames(inlineToolbarVisible && 'is-visible')}
			>
				<ButtonGroup orientation="horizontal">
					{this.renderButtonGroupItems()}
					{this.renderDivider()}
					<Tippy
						appendTo={forwardedRef.current}
						placement="right-start"
						trigger="click"
						animation="shift-away"
						animateFill={false}
						theme="min-width-small inline-toolbar-menu"
						interactive
						onCreate={this.onCreate}
						content={
							<ButtonGroup>
								{this.renderFurtherButtonGroupItems()}
							</ButtonGroup>
						}
					>
						<Button icon={<Icon name="dot-3" />} highContrast />
					</Tippy>
				</ButtonGroup>
				{this.renderLinkInput()}
			</Toolbar>,
			document.getElementById('root')
		)
	}
}

InlineToolbarComponent.propTypes = {
	editor: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
}

InlineToolbarComponent.defaultProps = {
	editor: null,
}

const InlineToolbarComponentWrapper = translate()(InlineToolbarComponent)
const InlineToolbar = React.forwardRef((props, ref) => (
	<InlineToolbarComponentWrapper {...props} forwardedRef={ref} />
))
export default InlineToolbar
